export const inputWidth = '270px';
